import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import sprintf from 'i18next-sprintf-postprocessor';
import HttpBackend from 'i18next-http-backend';
import { locales } from '../../../../scripts/translations/locales';

export { locales };

// normalize languages detected:
// - fil-PH is a legacy alias for tl-PH;
// - sometimes browsers can detect en-US instead of en;
const LOCALE_ALIASES = { 'fil-PH': 'tl-PH', 'en-US': 'en' };
const normalizeLocale = locale => LOCALE_ALIASES[locale] || locale;

const validLocales = new Set([...locales, ...Object.keys(LOCALE_ALIASES)]);

const customPathDetector = {
  name: 'customPath',
  lookup() {
    const path = window.location.pathname;
    // Match both 'es' and 'es-MX' format locales
    const localeMatch = path.match(/^\/([a-z]{2,3}(?:-[A-Z]{2,3})?)\//);
    if (localeMatch && validLocales.has(localeMatch[1])) {
      const detectedLocale = localeMatch[1];
      const locale = normalizeLocale(detectedLocale);
      if (locale !== detectedLocale) {
        const newPath = path.replace(`/${detectedLocale}/`, `/${locale}/`);
        window.history.replaceState(null, '', newPath + window.location.search + window.location.hash);
      }
      return locale;
    }
    const stored = localStorage.getItem('i18nextLng');
    if (stored && validLocales.has(stored)) {
      return normalizeLocale(stored);
    }
    return 'en';
  },
};

const detectedLang = customPathDetector.lookup();

i18n
  // Don't use languageDetector during init since we're setting lng explicitly
  .use(sprintf)
  .use(HttpBackend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    lng: detectedLang || 'en', // Explicitly set the detected language
    fallbackLng: 'en',
    partialBundledLanguages: true,
    initImmediate: false, // Make initialization synchronous
    languages: locales,
    ns: ['common', 'reactifi'],
    defaultNS: 'common',
    fallbackNS: ['common', 'reactifi'],
    keySeparator: '>',
    react: {
      useSuspense: true,
    },
    nsSeparator: '|',
    returnObjects: true,
    returnEmptyString: false,
    interpolation: {
      escapeValue: false,
      formatSeparator: ',',
      format: function (value, format) {
        if (format === 'uppercase') return value.toUpperCase();
        return value;
      },
    },
    backend: {
      loadPath: (languages, namespaces) => {
        const lng = normalizeLocale(languages[0]);
        return `/locales/${namespaces[0]}/${lng}/translations.json`;
      },
    },
  });

// Proxy to convert fil-PH to tl-PH when accessing i18n.language
const i18nProxy = new Proxy(i18n, {
  get(target, prop) {
    if (prop === 'language') {
      return normalizeLocale(target.language);
    }
    const value = target[prop];
    return typeof value === 'function' ? value.bind(target) : value;
  },
});
i18n.on('languageChanged', lng => {
  localStorage.setItem('i18nextLng', lng);
});

export default i18nProxy;
